import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-in_the_line",
  "use": "icon-in_the_line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-in_the_line\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M12.8,12H16v1.6H11.2V8h1.6ZM12,18.4A6.4,6.4,0,1,0,5.6,12,6.41,6.41,0,0,0,12,18.4ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol